<template>
  <div>
    <div class="con">
      <!-- pdf在线阅读 -->
      <div class="content_box">
        <div class="content_left">
          <div class="pdf-container" id="testx">
            <iframe :src="pdfUrl" style="width: 968px; height: 863px"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSysFileInfoPreview, getArticleByIdList } from "@/api/api";
export default {
  mounted() {
    this.init();
    // this.getpdf();
  },
  data() {
    return {
      pdfUrl: "",
      show: true,
      list: [
        {
          tit: "正文",
          list: [
            { name: "", count: "" },
            { name: "", count: "" },
          ],
        },
        {
          tit: "作者信息",
          list: [
            { name: "基金", count: "0" },
            { name: "关键词", count: "0" },
          ],
        },
        {
          tit: "English Abstract",
          list: [
            { name: "", count: "" },
            { name: "", count: "" },
          ],
        },
        {
          tit: "评论",
          list: [
            { name: "阅读", count: "6" },
            { name: "评论", count: "0" },
          ],
        },
        {
          tit: "相关资源",
          list: [
            { name: "引用", count: "|" },
            { name: "论文", count: "|" },
            { name: "视频", count: "" },
          ],
        },
      ],
      listValue: 0,
      details: "",
      outList: ["EndNote", "NoteExpress", "RefWorks", "NoteFirst"],
      tip: true,
      detail: {},
    };
  },
  methods: {
    getpdf(id) {
      getSysFileInfoPreview(id, true).then((res) => {
        this.pdfUrl = window.URL.createObjectURL(res.data);
      });
    },
    async init() {
      const res = await getArticleByIdList({
        id: this.$route.query.id,
      });
      if (res.status === 200) {
        this.detail = res.data;
        this.getpdf(this.detail.fileId);
      }
    },
    //导出
    output(id, type) {
      var ids = [id];
      this.$api.exportTxt(ids, type);
    },
    //导出pdf查看
    downloadPDF(x) {
      this.$api.downloadCore(x);
    },
    closeTip() {
      this.tip = false;
    },
  },
};
</script>

<style scoped>
.con {
  width: 968px;
  margin: 0 auto;
  text-align: left;
  /* min-height: 800px; */
}
.con::after {
  content: "";
  clear: both;
  display: block;
}
.article_head_title {
  height: 40px;
  font-size: 18px;
  color: #999999;
  margin-top: 30px;
}
.main_title {
  line-height: 42px;
  font-size: 30px;
  color: #333;
}
.article_authors {
  height: 50px;

  font-size: 14px;
  color: #999;
  text-align: center;
  display: flex;
  justify-content: start;
  align-items: center;
}
.article_authors::after {
  content: "";
  clear: both;
  display: block;
}
.article_authors li {
  padding: 9px 0;
  font-size: 14px;
  color: #999;
  text-align: center;
}
.article_authors li span {
  color: #333;
  text-align: center;
  cursor: default;
  padding: 2px 6px;
}
.article_source {
  color: #666;
  width: 968px;
  height: 30px;
  line-height: 30px;
  padding-left: 6px;
  box-sizing: border-box;
  font-size: 14px;
  margin-bottom: 15px;
}
.article_abstract {
  transition: 0.5s;
  overflow: hidden;
  display: block;
  border-top: 1px #2a7c8a solid;
  border-left: 5px solid #2a7c8a;
  border-right: 1px solid #2a7c8a;
  line-height: 1.8;
  padding: 20px;
  font-size: 14px;
  /* min-height: 20px; */
}
.article_abstracttoggle {
  padding: 0 20px;
  height: 0 !important;
}

.article_abstract_bot {
  position: relative;
  height: 17px;
  border: 1px #2a7c8a solid;
  border-top: 0;
  border-left: 5px solid #2a7c8a;
}
.article_abstract_bot > img {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  cursor: pointer;
}
.two {
  margin-top: -8px;
}
.quote_box {
  position: relative;
  border: 1px solid #2a7c8a;
  padding: 16px 0;
  height: 118px;
  margin-top: 15px;
}
.quote_content {
  width: 738px;
  line-height: 1.8;
  font-size: 13px;
  color: #666;
  float: left;
  margin-left: 16px;
}
.quote_content .refExport {
  position: absolute;
  bottom: 0;
  margin-bottom: 5px;
}
.quote_content .refExport span + span {
  color: #2a7c8a;
  cursor: pointer;
  margin: 0 5px;
}
.quote_content .refExport span + span:hover {
  opacity: 0.7;
}
.content_tab {
  margin-top: 10px;
}
.content_tab::after {
  content: "";
  clear: both;
  display: block;
}
.content_tab_mod {
  width: 186px;
  float: left;
  margin-left: 7px;
  background: #e9f2f3;
  height: 110px;
  color: #333;
  cursor: pointer;
  border-radius: 0px 0px 5px 5px;
}
.content_tab .tit {
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.content_tab .oth {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
}
/* .content_tab .oth>span{
      color: #2a7c8a;
} */
.content_tab_mod0 {
  width: 188px;
  background: #2a7c8a;
  height: 130px;
  color: #fff;
  border-radius: 0px 0px 5px 5px;
}
.content_box {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.content_box .content_left {
  width: 722px;
  padding-bottom: 20px;
}
.content_left .copy_right {
  border: 2px solid #ee0000;
  border-radius: 5px;
  font-size: 16px;
  background-color: #fff3cf;
  padding: 10px 12px;
  text-align: left;
}
.content_left .copy_right .warning {
  margin-right: 10px;
  height: 20px;
  width: 20px;
  background: url("../../assets/images/warning.png") no-repeat;
  float: left;
  cursor: pointer;
}
.content_left .copy_right .txt {
  float: left;
  width: 635px;
  line-height: 22px;
  font-size: 14px;
}
.content_left .copy_right .close_btn {
  height: 20px;
  width: 20px;
  background: url("../../assets/images/wrong.png") no-repeat center;
  float: right;
  cursor: pointer;
}
.pdf-container {
  height: 863px;
  width: 968px !important;
}
.content_box .content_wz_right {
  height: max-content;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.mod .mod_tit_on {
  width: 109px;
  height: 30px;
  line-height: 30px;
  float: left;
  background: #5596a1;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.mod .mod_tit .mod_tit_no {
  width: 109px;
  height: 30px;
  line-height: 30px;
  float: left;
  background: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
  color: #5596a1;
  text-align: center;
  cursor: pointer;
}
.content_left > .auth_info_li {
  width: 722px;
  padding: 10px;
  margin: 10px;
}
.content_left p,
.content_left div {
  width: 700px;
}
.content_left > .auth_info_li > .tit {
  font-size: 24px;
  color: #2a7c8a;
  margin-bottom: 15px;
  line-height: 24px;
}
.content_left > .auth_info_li > .con {
  line-height: 28px;
  font-size: 14px;
  margin: 5px 0px 5px 0px;
}
.content_left > .auth_info_li > .con > .con-term {
  overflow: hidden;
}
.content_left > .auth_info_li > .con > .aff {
  color: #888;
}
.content_left > .auth_info_li > .con > .mod_con_line_text {
  color: #333;
}
.content_left > .en_col {
  padding: 5px;
  font-size: 24px;
  color: #999999;
}
.content_left > .en_tit {
  padding: 5px;
  font-size: 24px;
  line-height: 36px;
}
.content_left > .en_auth {
  font-size: 16px;
  line-height: 30px;
  padding: 3px;
  margin-top: 7px;
}
.content_left > .en_code {
  font-size: 16px;
  padding: 3px;
  margin-bottom: 5px;
}
.content_left > .en_date {
  font-size: 14px;
  padding: 3px;
  margin-bottom: 5px;
}
.content_left > .en_cite {
  font-size: 14px;
  padding: 3px;
  margin-bottom: 5px;
}
.content_left > .en_cite > span,
.content_left > .en_date > span {
  color: #333;
}
.content_left > .en_abs {
  border-top: 1px dotted #5596a1;
  font-size: 14px;
  line-height: 30px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 3px;
  text-align: justify;
}
.content_left .en_abs .en_abs_tit {
  display: block;
  font-size: 24px;
  font-weight: 900;
  padding: 25px 3px 20px;
}
.content_left .en_abs .title {
  font-weight: bold;
  float: left;
  padding-right: 15px;
}
.content_left .aff {
  color: #888;
}
.copy_rig_Wra {
  width: 968px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.content_wz_right {
  overflow: hidden;
}

.icons {
  width: max-content !important;
  cursor: pointer;
}
.icons_one {
  width: max-content !important;
  display: flex;
  justify-content: space-between;
}

.icons_one img {
  width: 29px;
  height: 46px;
  margin-right: 20px;
}

.icons_one .mod {
  width: max-content !important;
}
.mod .mod_tit {
  display: flex;
  flex-wrap: wrap;
  width: 109px;
}
</style>